import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Copy } from 'lucide-react';
import { Button } from './button.js';
import { copyToClipboard } from '../lib/copy-to-clipboard.js';
/**
 * `Button` that copies `value` to the clipboard on click and toasts the
 * outcome — the one sanctioned click-to-copy shape in the kit (see the
 * CLAUDE.md "UI-kit discipline" rule). Icon-only by default (`variant="ghost"
 * size="icon"`); pass `children` for a labelled button (e.g. the chat
 * header's case-number copy) or override `variant`/`size`/`className` for any
 * other shape. `successMessage`/`errorMessage` default to Russian text —
 * override them per call-site for a different locale/wording.
 */
export const CopyButton = React.forwardRef(({ value, ariaLabel, children, successMessage = 'Скопировано', errorMessage = 'Не удалось скопировать', variant = 'ghost', size = 'icon', ...rest }, ref) => (_jsxs(Button, { ref: ref, type: "button", variant: variant, size: size, ...rest, "aria-label": ariaLabel, onClick: () => void copyToClipboard(value, successMessage, errorMessage), children: [children, _jsx(Copy, { className: "h-3 w-3", "aria-hidden": "true" })] })));
CopyButton.displayName = 'CopyButton';
//# sourceMappingURL=copy-button.js.map